module.exports = __webpack_public_path__ + "img/car-electric-second_ec-phev.37ac3b39.jpg";